function parseJsonAttribute(element, attributeName, fallback, onError = null) {
    if (element === null || element === undefined) {
        return fallback;
    }

    const value = element.getAttribute(attributeName);
    if (value === null || value === '') {
        return fallback;
    }

    try {
        return JSON.parse(value) ?? fallback;
    } catch (error) {
        if (onError !== null) {
            onError(error);
        }

        return fallback;
    }
}

export default parseJsonAttribute;
